import { useParams } from "react-router-dom";
import s from "./TourDetails.module.scss";

import Footer from "../Footer";
import TourHero from "../TourHero/TourHero";
import TourFeatureStrip from "../TourFeatureStrip/TourFeatureStrip";
import TourYoutubeEmbed from "../TourYoutubeEmbed/TourYoutubeEmbed";
import TourGallerySlider from "../TourGallerySlider/TourGallerySlider";
import TourVideoGallery from "../TourVideoGallery/TourVideoGallery";
import TourScheduleLayout from "../TourScheduleLayout/TourScheduleLayout";
import Notes from "../Notes/Notes";
import Faq from "../Faq/Faq";
import Header from "../Header/Header";
import MobileFloatingCTA from "../MobileFloatingCTA/MobileFloatingCTA";

import { useLanguage } from "../contexts/LanguageContext";
import { tourDetails } from "../data/tours";

const TourDetails = () => {
  const { id } = useParams();
  const { lang } = useLanguage();

  const data = tourDetails?.[lang]?.[id] || tourDetails?.JP?.[id];

  if (!data) return null;

  const tourYoutubeUrl = data.youtubeUrl || data.heroYoutubeUrl;

  return (
    <div className={s.root}>
      <Header />

      <TourHero data={data} />

      <TourFeatureStrip
        highlights={data.highlights}
        language={lang}
        intro={data.featureIntro}
      />

      {tourYoutubeUrl ? (
        <section className={s.mediaShowcase}>
          <div className={s.mediaMovie}>
            <TourYoutubeEmbed
              url={tourYoutubeUrl}
              title={`${data.heroTitle || data.title} video`}
              isCompact
            />
          </div>

          <div className={s.mediaGallery}>
            <TourGallerySlider
              images={data.images}
              isVertical={data.isVertical}
              isCompact
            />
          </div>
        </section>
      ) : (
        <TourGallerySlider images={data.images} isVertical={data.isVertical} />
      )}

      <TourVideoGallery videos={data.videoGallery} language={lang} />

      <TourScheduleLayout
        showCustomize={data.showCustomize}
        scheduleItems={data.scheduleItems}
        price={data.price}
        detailItems={data.detailItems}
        includedItems={data.included}
        notIncludedItems={data.notIncluded}
        showScheduleImages={data.showScheduleImages !== false}
      />

      <Faq items={data.faqs} />
      <Notes columns={data.noteColumns} />
      <Footer />
      <MobileFloatingCTA />
    </div>
  );
};

export default TourDetails;
